function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var t = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var H = Object.prototype.hasOwnProperty,
    V = Object.prototype.propertyIsEnumerable;

var n = function n(e, C, l) {
  return C in e ? t(e, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: l
  }) : e[C] = l;
},
    d = function d(e, C) {
  for (var l in C || (C = {})) {
    H.call(C, l) && n(e, l, C[l]);
  }

  if (i) {
    var _iterator = _createForOfIteratorHelper(i(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var l = _step.value;
        V.call(C, l) && n(e, l, C[l]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

import * as o from "react";

function v(e) {
  return o.createElement("svg", d({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), o.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15H7V14H5V12H8.5C8.776 12 9 11.776 9 11.5C9 11.224 8.776 11 8.5 11H7.5C6.122 11 5 9.878 5 8.5C5 7.292 5.86 6.283 7 6.05V5H9V6H11V8H7.5C7.224 8 7 8.224 7 8.5C7 8.776 7.224 9 7.5 9H8.5C9.878 9 11 10.122 11 11.5C11 12.708 10.14 13.717 9 13.95V15ZM16 10.262V1C16 0.654 15.82 0.332 15.526 0.15C15.231 -0.033 14.862 -0.049 14.553 0.105L11.072 1.846L8.555 0.168C8.219 -0.056 7.781 -0.056 7.445 0.168L4.928 1.846L1.447 0.105C1.138 -0.049 0.769 -0.033 0.474 0.15C0.18 0.332 0 0.654 0 1V19C0 19.347 0.18 19.668 0.474 19.851C0.635 19.95 0.817 20 1 20C1.153 20 1.306 19.965 1.447 19.894L4.928 18.154L7.445 19.832C7.781 20.056 8.219 20.056 8.555 19.832L10.044 18.838C10.016 18.563 10 18.283 10 18C10 14.274 12.551 11.152 16 10.262Z",
    fill: "black"
  }), o.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18.9849H17V13.9849H19V16.9849H21V18.9849ZM18 11.9849C14.692 11.9849 12 14.6779 12 17.9849C12 21.2939 14.692 23.9849 18 23.9849C21.308 23.9849 24 21.2939 24 17.9849C24 14.6779 21.308 11.9849 18 11.9849Z",
    fill: "black"
  }));
}

export { v as ReactComponent };